import * as React from 'react';
import styled from 'styled-components';

const LargeImage = styled.img`
  height: 130px;
  width: 130px;
  border-radius: 50%;
  background-color: hsla(0, 0%, 100%, 0.8);
  font-size: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MediumImage = styled(LargeImage as any)`
  height: 40px;
  width: 40px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SmallImage = styled(LargeImage as any)`
  height: 30px;
  width: 30px;
`;

const XLargeImage = styled(LargeImage as any)`
  height: 25rem;
  width: 25rem;
`;

interface IProps {
  alt?: string;
  title?: string;
  size: 'x-large' | 'large' | 'medium' | 'small' | 'list-avatar';
  style?: React.CSSProperties;
  src: string;
  onClick?: () => void;
}

export const Image = (props: IProps): React.ReactElement => {
  switch (props.size) {
    case 'small':
    case 'list-avatar':
      return <SmallImage {...props} />;
    case 'medium':
      return <MediumImage {...props} />;
    case 'x-large':
      return <XLargeImage {...props} />;
    default:
      return <LargeImage {...props} />;
  }
};
